export enum Status {
  NotStarted = 'Not Started',
  Started = 'Started',
  InProgress = 'In Progress',
  Finished = 'Finished',
}
